<template>
  <div class="c-modal-mater">
    <Button type="primary" ghost style="margin-left: 0" @click="visible = true">
      {{ value.length ? `已选 ${value.length} 个素材` : '请选择素材' }}
    </Button>

    <Modal
      v-model="visible"
      :width="1200"
      :closable="false"
      :mask-closable="false"
      :transfer="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <template slot="header">
        <h2 class="c-header">
          <span
            >选择素材 (<ins :class="{ 'g-error-text': ilen > max }">{{ ilen }}</ins
            >/{{ max }})</span
          >
          <div v-if="ilen" class="c-check-all c-result-checkbox">
            <Checkbox v-model="result" @on-change="changeResult">仅显示已选素材</Checkbox>
          </div>
          <a href="javascript:;" class="g-pull-right" @click.prevent="handleClear">清空全部</a>
          <div v-if="len && !result" class="c-check-all g-pull-right">
            <Checkbox v-model="all" :indeterminate="indeter" :disabled="!all && disabledStat">全选</Checkbox>
            <span class="c-cataract" :class="{ 'm-disabled': !all && disabledStat }" @click.stop="selectAll"></span>
          </div>
        </h2>
      </template>
      <Form v-if="!result" class="filter-box" :label-width="60" inline @submit.native.prevent>
        <FormItem :label-width="0">
          <Input ref="search" v-model="keyword" search size="small" placeholder="请输入素材名称" style="width: 160px" @on-search="query" />
        </FormItem>
        <FormItem label="素材类型">
          <Select v-model="imageType" clearable size="small" placeholder="全部" style="width: 80px">
            <Option v-for="type in typeData" :key="type.id" :value="type.id">{{ type.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="内容标签">
          <el-select
            v-model="labelIds"
            :popper-append-to-body="false"
            :multiple-limit="10"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
            style="width: 190px"
          >
            <el-option v-for="label in labelData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </FormItem>
        <FormItem label="上传时间">
          <DatePicker
            v-model="datetime"
            :options="datetimeOption"
            type="daterange"
            placement="bottom-end"
            placeholder="请选择"
            style="width: 180px"
            size="small"
          />
        </FormItem>
        <FormItem label="设计者" :label-width="50">
          <el-select
            v-model="designerIds"
            :popper-append-to-body="false"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
            style="width: 190px"
          >
            <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label-width="0">
          <Button type="primary" class="m-search-btn" size="small" @click="query">查询</Button>
        </FormItem>
      </Form>
      <div class="c-table-list" v-loading="loading">
        <div v-if="!result" class="c-table-box">
          <div class="image-box">
            <template v-if="len">
              <div class="item-wrapper" v-for="item in materialData" :key="item.id">
                <div class="material-wrapper" @mouseenter="$set(item, '_hoverState', true)" @mouseleave="$set(item, '_hoverState', false)">
                  <img :src="item.addr" class="item-background" />
                  <video
                    v-if="item.type === 2"
                    :poster="item.addr"
                    :src="item.field1"
                    class="video-item"
                    :controls="item._hoverState"
                    preload="none"
                  >
                    您的浏览器不支持 video 标签
                  </video>
                  <img v-else :src="item.addr" :class="[item.width >= item.height * 1.77 ? 'img-item-cross' : 'img-item-vertical']" />
                  <Checkbox
                    v-model="item.check"
                    :disabled="!item.check && disabledStat"
                    border
                    size="large"
                    class="check-item"
                    :class="{ 'checked-item': item.check }"
                  />
                  <div class="check-box" :class="{ 'm-disabled': !item.check && disabledStat }" @click="selectItem(item)"></div>
                </div>
                <div class="info-wrapper" @click="selectItem(item)">
                  <div class="item-title">
                    <Tooltip :content="item.imageName" :max-width="600" trigger="hover" placement="top-start"
                      ><span class="tool-span">{{ item.imageName }}</span></Tooltip
                    >
                  </div>
                </div>
              </div>
            </template>
            <no-data v-else />
          </div>
          <Page
            :current.sync="pageIndex"
            :total="total"
            :page-size="pageSize"
            size="small"
            class="page-index"
            show-total
            @on-change="changePageIndex"
          />
        </div>
        <div v-else class="c-table-box">
          <div class="image-box">
            <div class="item-wrapper" v-for="item in selectionData" :key="item.id">
              <div class="material-wrapper" @mouseenter="$set(item, '_hoverState', true)" @mouseleave="$set(item, '_hoverState', false)">
                <img :src="item.addr" class="item-background" />
                <video
                  v-if="item.type === 2"
                  :poster="item.addr"
                  :src="item.field1"
                  class="video-item"
                  :controls="item._hoverState"
                  preload="none"
                >
                  您的浏览器不支持 video 标签
                </video>
                <img v-else :src="item.addr" :class="[item.width >= item.height * 1.77 ? 'img-item-cross' : 'img-item-vertical']" />
                <Checkbox
                  v-model="item.check"
                  :disabled="!item.check && disabledStat"
                  border
                  size="large"
                  class="check-item"
                  :class="{ 'checked-item': item.check }"
                />
                <div class="check-box" :class="{ 'm-disabled': !item.check && disabledStat }" @click="selectItem(item)"></div>
              </div>
              <div class="info-wrapper" @click="selectItem(item)">
                <div class="item-title">
                  <Tooltip :content="item.imageName" :max-width="600" trigger="hover" placement="top-start"
                    ><span class="tool-span">{{ item.imageName }}</span></Tooltip
                  >
                </div>
              </div>
            </div>
          </div>
          <Page
            :current.sync="ipageIndex"
            :total="ilen"
            :page-size="ipageSize"
            size="small"
            class="page-index"
            show-total
            @on-change="changeiPageIndex"
          />
        </div>
      </div>
      <Row slot="footer" :gutter="12">
        <Button type="default" @click="cannel">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, trim, formatDate, deepCopy } from '@/common/js/utils'
import shortcuts from '@/data/shortcuts'

import { queryImageByPage } from '@/api/material.model'
let asyncPage

export default {
  name: 'MaterModal',
  props: {
    value: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },
    typeData: {
      type: Array
    },
    labelData: {
      type: Array
    },
    operatorData: {
      type: Array
    }
  },
  computed: {
    indeter() {
      return this.materialData.some((ret) => ret.check) && !this.materialData.every((ret) => ret.check)
    },
    len() {
      return this.materialData.length
    },
    ilen() {
      return this.selection.length
    },
    all() {
      const len = this.materialData.filter((ret) => ret.check).length
      return this.len === len
    },
    disabledStat() {
      return this.disabled || this.ilen >= this.max
    }
  },
  data() {
    return {
      visible: null,
      loading: null,
      result: null,
      pageIndex: 1,
      pageSize: 12,
      total: 0,
      ipageIndex: 1,
      ipageSize: 12,

      designerIds: [],
      labelIds: [],
      datetime: [],
      imageType: null,
      keyword: null,

      selection: [],
      materialData: [],
      selectionData: [],
      datetimeOption: {
        shortcuts,
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      } // 快速选择配置
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.query()
        this.temData = deepCopy(this.selection)
      } else {
        this.result = false
        this.pageIndex = 1
        this.ipageIndex = 1
      }
    },
    selectItem(item) {
      const { check, id } = item
      const index = this.materialData.findIndex((ret) => ret.id === id)
      const isDul = this.selection.some((ret) => ret.id === id)

      if (this.disabledStat && !check) return
      if (check) {
        // 反选
        const idx = this.selection.findIndex((ret) => ret.id === id)
        idx > -1 && this.selection.splice(idx, 1)
        if (this.result) this.selectionData = this.calcTableData()
      } else if (!isDul) this.selection.push(item)
      if (index > -1) this.$set(this.materialData[index], 'check', !check)
    },
    handleClear() {
      const someMater = this.materialData.some((ret) => ret.check)
      this.selection = []
      if (someMater) {
        this.materialData.forEach((ret) => {
          this.$set(ret, 'check', false)
        })
      }
    },
    selectAll() {
      const all = this.materialData.every((ret) => ret.check)
      if (all) {
        this.materialData.forEach((ret) => {
          this.selectItem(ret)
        })
      } else {
        this.materialData
          .filter((ret) => !ret.check)
          .every((ret) => {
            if (this.disabledStat) return
            this.selectItem(ret)
            return true
          })
      }
    },
    changeResult(val) {
      if (val) {
        this.ipageIndex = 1
        this.selectionData = this.calcTableData()
      }
    },
    save() {
      const ids = this.selection.map((ret) => ret.id)
      if (this.max < ids.length) {
        this.$Message.error(`超过了素材数量限制，请删减到 ${this.max} 以内！`)
        return
      }
      this.$emit('input', ids)
      this.visible = false
    },
    cannel() {
      this.visible = false
      this.selection = deepCopy(this.temData)
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.query({ pageIndex: this.pageIndex })
    },
    changeiPageIndex(index) {
      this.ipageIndex = index
      this.selectionData = this.calcTableData()
    },
    calcTableData() {
      const start = (this.ipageIndex - 1) * this.ipageSize
      const end = this.ipageIndex * this.ipageSize
      return this.selection.slice(start, end)
    },
    query(bool) {
      asyncPage() // 同步分页
      const [begin, end] = this.datetime
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderColumn: 'create_time',
        orderSort: 'desc',
        keyword: trim(this.keyword),
        typeImageAndVideo: 1,
        imageType: this.imageType,
        labelIds: this.labelIds,
        designerIds: this.designerIds,
        beginTime: begin,
        endTime: end
      }

      this.loading = true
      this.materialData = []
      queryImageByPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            let defCheck
            const { total_number } = page_info
            if (bool) defCheck = this.selection.map((ret) => ret.id)
            else {
              defCheck = this.value
              // if (!this.ilen) {
              // this.selection = await getforIDtoItem() 分页接口初始化反显
              // }
            }
            this.materialData = list.map((ret) => {
              ret.check = defCheck.includes(ret.id)
              return ret
            })
            this.total = total_number || 0
            asyncPage = () => {}
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    }
  },
  created() {
    const lastYear = moment().subtract(1, 'years').format('YYYY-MM-DD')
    const now = formatDate(new Date(), 'yyyy-MM-dd')
    this.datetime = [lastYear, now]
  },
  watch: {
    datetime() {
      asyncPage = () => {
        this.pageIndex = 1
      }
    },
    designerIds() {
      asyncPage = () => {
        this.pageIndex = 1
      }
    },
    labelIds() {
      asyncPage = () => {
        this.pageIndex = 1
      }
    },
    imageType() {
      asyncPage = () => {
        this.pageIndex = 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-modal-mater {
  position: relative;

  .vertical-center-modal {
    .ivu-btn {
      margin-left: 6px !important;
    }
  }

  .c-header {
    line-height: 20px;
    font-size: 14px;
    font-weight: 700;

    a {
      font-weight: 400;
    }

    .c-result-checkbox {
      display: inline-block;

      label {
        font-weight: 400;
      }
    }

    .c-check-all {
      position: relative;
      padding-left: 12px;
      padding-right: 12px;

      .c-cataract {
        position: absolute;
        width: 42px;
        height: 34px;
        top: 0;
        right: 16px;
        z-index: 8;
        cursor: pointer;
      }
    }
  }

  .filter-box {
    flex: 0 0 auto;
    padding-bottom: 6px;
  }

  .c-table-list {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 520px;
  }

  .c-table-box {
    width: 100%;
    height: 100%;
  }

  .image-box {
    height: calc(100% - 40px);
    padding: 10px 0;
    position: relative;
    overflow-y: scroll;

    .item-wrapper {
      display: inline-block;
      position: relative;
      width: 275px;
      height: 188px;
      border: 1px solid #ebebeb;
      background-color: #545454;
      margin: 0 14px 14px 0;
      box-sizing: border-box;
      transition: all 0.4s;

      &:hover {
        box-shadow: 0 0 10px 8px #ebebeb;

        .material-wrapper {
          .check-item {
            opacity: 1;
          }
        }
      }

      .material-wrapper {
        position: relative;
        height: 154px;
        width: 100%;
        overflow: hidden;

        .check-box {
          cursor: pointer;
          width: 100%;
          height: 80px;
          left: 0;
          top: 0;
          position: absolute;
          z-index: 8;
        }

        .check-item {
          position: absolute;
          z-index: 3;
          left: 6px;
          top: 4px;
          margin: 0;
          cursor: pointer;
          opacity: 0;
          transition: all 0.4s;

          &.checked-item {
            opacity: 1;
          }
        }

        .video-item {
          height: 100%;
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .img-item-cross {
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .img-item-vertical {
          height: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .item-background {
          width: 100%;
          height: 100%;
          filter: blur(10px);
        }
      }
    }

    .info-wrapper {
      height: calc(100% - 154px);
      padding: 4px 5px;
      background-color: #545454;

      .item-title {
        color: #fff;

        ::v-deep .tool-span {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 260px;
          line-height: 22px;
          display: inline-block;
        }
      }
    }
  }

  .page-index {
    margin-top: 7px;
    text-align: right;
  }

  ::v-deep .ivu-modal-body {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
    text-align: left;
  }

  ::v-deep .el-input input {
    padding: 0 8px;
  }

  ::v-deep .el-select__tags {
    padding-left: 4px;
  }

  ::v-deep .el-select__input {
    margin-left: 2px;
  }

  ::v-deep .el-select .el-tag {
    margin-left: 4px;
    display: flex;
    align-items: center;

    .el-select__tags-text {
      max-width: 78px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
